export const billAmountContent = {
  title: 'How much can you save?',
  subtitle:
    "This is the remaining amount you owe. Don't include payments already made or discounts received.",
  amountLabel: 'Bill Amount',
  amountPlaceholder: '$',
  providerLabel: 'Medical Provider',
  providerPlaceholder: 'Start typing...',
  addAnotherLabel: 'Add Another',
  modalTitle: 'Add Provider',
  modalHospitalLabel: 'Hospital name',
  modalCityLabel: 'City',
  modalStateLabel: 'State',
  modalSaveLabel: 'Save',
  modalCancelLabel: 'Cancel',
  continueLabel: 'Continue',
  errors: {
    amountRequired: 'Please enter a bill amount',
    amountPositive: 'Amount must be greater than 0',
    providerRequired: 'Please select a provider',
    minOneRow: 'At least one complete bill entry is required',
    providerDuplicate: 'This provider is already added',
  },
};
